import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const baseUrl = process.env.REACT_APP_API_URL;

export default function NotificationsPage() {
    const [currentUser, setCurrentUser] = useState(null);
    const [requests, setRequests] = useState([]);
    const [requestUsers, setRequestUsers] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        const user = localStorage.getItem("username");
        if (!user) return navigate("/login");

        fetch(`${baseUrl}/api/users/${user}`)
            .then(res => res.json())
            .then(async (data) => {
                setCurrentUser(data);
                const reqIds = data.circleRequests || [];
                setRequests(reqIds);

                const profiles = await Promise.all(
                    reqIds.map(id => fetch(`${baseUrl}/api/users/id/${id}`).then(res => res.json()))
                );
                setRequestUsers(profiles);
            })
            .catch(() => navigate("/login"));
    }, [navigate]);


    const handleAction = async (type, fromUserId) => {
        const endpoint = `${baseUrl}/api/users/circle/${type}`;
        const res = await fetch(endpoint, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ fromUserId, toUserId: currentUser._id }),
        });
        const data = await res.json();
        if (data) {
            setRequests(prev => prev.filter(id => id !== fromUserId));
        }
    };

    return (
        <div style={{ padding: "40px", maxWidth: "800px", margin: "100px auto 0 auto", position: "relative" }}>
            <button
                onClick={() => navigate(`/${currentUser?.username?.replace(/^@/, "")}`)}
                style={{
                    position: "absolute",
                    top: "20px",
                    left: "20px",
                    fontSize: "1.5rem",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#000000",
                }}
            >
                ✕
            </button>
            <h1>Notifications</h1>
            {requests.length === 0 ? (
                <p>No connection requests.</p>
            ) : (
                <ul>
                    {requestUsers.map((user) => (
                        <li key={user._id} style={{ marginBottom: "1rem" }}>
                            <span>{user.username}</span>
                            <button onClick={() => handleAction("accept", user._id)}>Accept</button>
                            <button onClick={() => handleAction("decline", user._id)}>Decline</button>
                        </li>
                    ))}

                </ul>
            )}
        </div>
    );

}
